import React from "react";
import { Card, Tag, Button, Space, Tooltip } from "antd";
import { UndoOutlined, BarChartOutlined, LinkOutlined } from "@ant-design/icons";
import { positionLabel } from "../../utils/positionMeta";

const STATUS_COLOR = { ACTIVE: "green", INACTIVE: "default" };

// View-only card. Management (edit / status toggle / delete) now lives in
// the PositionsOverview table — this component only browses and links out
// to stats, plus restore for the Deleted tab.
const AdItem = ({
  ad,
  group, // "live" | "upcoming" | "past" | "inactive" | "deleted"
  onRestore,
  onViewStats,
}) => {
  const isDeleted = group === "deleted";

  return (
    <Card
      hoverable={!isDeleted}
      style={{ opacity: isDeleted ? 0.6 : 1 }}
      cover={
        <div style={{ height: 140, overflow: "hidden", background: "#f5f5f5" }}>
          <img
            src={ad.image}
            alt={ad.name}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      }
      actions={
        isDeleted
          ? [
              <Tooltip title="Restore this ad" key="restore">
                <Button type="text" icon={<UndoOutlined />} onClick={onRestore}>
                  Restore
                </Button>
              </Tooltip>,
            ]
          : [
              <Tooltip title="View stats" key="stats">
                <Button type="text" icon={<BarChartOutlined />} onClick={onViewStats} />
              </Tooltip>,
            ]
      }
    >
      <Card.Meta
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {ad.name}
            </span>
            <Tag color={STATUS_COLOR[ad.status] || "default"}>{ad.status}</Tag>
          </div>
        }
        description={
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <span style={{ color: "#888" }}>{ad.organization}</span>

            <Space size={4} wrap>
              {ad.positions?.map((p) => (
                <Tag key={p} color={p === "*" ? "purple" : "blue"}>
                  {positionLabel(p)}
                </Tag>
              ))}
            </Space>

            <Space size={4} wrap>
              <Tag color={ad.paid ? "gold" : "default"}>{ad.paid ? "Paid" : "Free"}</Tag>
              <Tag>Weight: {ad.weight}</Tag>
            </Space>

            <span style={{ fontSize: 12, color: "#888" }}>
              {ad.durationFrom || "—"} → {ad.durationTo || "No end date"}
            </span>

            <span style={{ fontSize: 12, color: "#888" }}>
              👁 {ad.impressions ?? 0} · 🖱 {ad.clicks ?? 0}
            </span>

            {ad.link && (
              <a href={ad.link} target="_blank" rel="noopener noreferrer">
                <LinkOutlined /> View link
              </a>
            )}
          </Space>
        }
      />
    </Card>
  );
};

export default AdItem;
